"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupCards = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _headlineLockup = _interopRequireDefault(require("@site/pattern-library-core/headline-lockup"));
var _motionMove = _interopRequireDefault(require("../animation/motion-move"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _actions = _interopRequireDefault(require("../../elements/other/actions"));
var _image = require("@site/pattern-library-core/image");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _quickLearnModalInnerCard = _interopRequireDefault(require("./quick-learn-modal-inner-card"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SectionWrapper = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionWrapper",
  class: "pl-s1ylirmd"
});
const Container = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "Container",
  class: "pl-c1vezzaz"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hms4hwx"
});
const ModalCardsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ModalCardsContainer",
  class: "pl-m4goo1k"
});
const BottomCtaContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BottomCtaContainer",
  class: "pl-b1t3pdny"
});
const groupCards = cards => {
  return cards?.reduce((pairs, _, index) => {
    if (index % 2 === 0) {
      pairs.push(cards.slice(index, index + 2));
    }
    return pairs;
  }, []);
};

/**
 * RTBCardModalItem Component.
 *
 * @param {Object} props React props
 * @param {string} props.id Card modal id
 * @param {string} props._name Card modal name
 * @param {string} props.layoutClasses Card layout classes
 * @param {Array} props.cards Card data
 * @param {Array} props.ctas Call to action data
 * @param {Object} props.bottomCta Bottom call to action data
 * @returns {React.ReactElement} RTBCardModalItem Component
 * @public
 */
exports.groupCards = groupCards;
function RTBCardModalItem({
  id,
  _name,
  cards,
  layoutClasses = 'default|reverse|dual',
  ctas,
  bottomCta,
  eyebrowTag = 'h2',
  headlineTag = 'h3',
  ...rest
}) {
  const layoutClassArray = layoutClasses.split('|');
  const cardPairs = (0, _react.useMemo)(() => groupCards(cards), [...cards]);
  return /*#__PURE__*/_react.default.createElement(SectionWrapper, {
    id: `id-${id}`,
    _name: _name,
    dataCy: "rtb-card-modal-section",
    padding: "none",
    margin: "none"
  }, /*#__PURE__*/_react.default.createElement(Container, {
    variant: "moveUpFixed",
    staggerChildren: true,
    intensityMultiplier: 2,
    triggerOnce: true,
    className: "rtb-card-modal-container"
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "headline-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_headlineLockup.default, (0, _extends2.default)({
    textAlign: "start",
    headlineSize: "h2",
    eyebrowTag: eyebrowTag,
    headlineTag: headlineTag
  }, rest)), ctas && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "ctas"
  }, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: ctas
  }))), cardPairs?.map((pair, index) => {
    const layoutClass = layoutClassArray[index] || 'default';
    return /*#__PURE__*/_react.default.createElement(ModalCardsContainer, {
      "data-cy": "card-group",
      key: index,
      className: layoutClass
    }, pair.map((item, idx) => /*#__PURE__*/_react.default.createElement(_quickLearnModalInnerCard.default, {
      key: idx,
      item: item,
      layoutClass: layoutClass
    })));
  }), bottomCta && /*#__PURE__*/_react.default.createElement(BottomCtaContainer, {
    "data-cy": "bottom-ctas"
  }, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: [bottomCta]
  }))));
}
var _default = exports.default = RTBCardModalItem;
RTBCardModalItem.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  eyebrow: _propTypes.default.string,
  eyebrowTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'p']),
  heading: _propTypes.default.string,
  headlineTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'p']),
  ctas: _propTypes.default.array,
  cards: _propTypes.default.arrayOf(_propTypes.default.shape({
    heading: _propTypes.default.string,
    description: _propTypes.default.string,
    image: _propTypes.default.shape({
      url: _propTypes.default.string,
      altText: _propTypes.default.string
    })
  })),
  layoutClasses: _propTypes.default.oneOf(['default', 'reverse', 'dual']),
  image: _propTypes.default.shape(_image.imgPropShape),
  bottomCta: _propTypes.default.object
};